import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/ClipboardCheckFill.tsx
const ClipboardCheckFillIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M9 3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 5a2 2 0 0 1 2-2h2v3c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V3h2a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Zm11.707 7.207a1 1 0 0 0-1.414-1.414L11 14.086l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4Z",
		fill: props.fill || "currentColor"
	})]
}));
export { ClipboardCheckFillIcon };
